jQuery(document).ready(function($){
  var $window, $body, $header;
  var myStorage = window.localStorage;
  var arrLeonardGTMTrackingFormPath = [
    "/contact/",
    "/checkout/",
  ]

  //var arrLeonardGTMTrackingFormPathCTA2 = [
    //"/how-it-works/helpful-tools/",
  //]

  $(function() { initialise(); });

  function initialise() {
    initLeonardGTMTracking();
    getNewsletterRegistration();

    sameHeight($('#theme-container .shop-container li.product.type-product .product-categories'));

    $('.shipping-calculator-button').on('click', function() {
      setTimeout(function(){
        $('.shipping-calculator-form #calc_shipping_country_field #select2-calc_shipping_country-container .select2-selection__placeholder').html('Country');
      }, 250)
    });

    var urlQuery = getUrlVars();

    if($('.swatch-container .p-attr-color').length) {
      $('.swatch-container').each(function() {
        var orderID = $(this).children('.p-attr-color').data('order');
        if(orderID > 5) {
          $(this).hide();
        }
      });

      if(urlQuery['filter_generic-colors'] || urlQuery['s']) {
        var term = '';
        if (urlQuery['filter_generic-colors']) {
          term = urlQuery['filter_generic-colors'];
        } else {
          term = urlQuery['s'];
        }
  
        $.ajax({
          url: ajaxurl,
          data: {
            'action':'ajax_generic_colors',
            'term' : term
          },
          success: successAjax
        });
      }
      else {
        $('.shop-container li.product.type-product').animate({
          opacity: 1,
        }, 750);
      }
    }
    
    $(document.body).trigger('wc_fragment_refresh');

    $.ajax({
      url: ajaxurl,
      data: {
        'action':'ajax_geolocation',
      },
      success: geolocalisation
    });

    $('#ship-to-different-address-checkbox').change(function() {
      if($(this).is(':checked')) {
        console.log('Is Checked');
        myStorage.setItem('isChecked', 'true');
      }
      else {
        console.log('Is Unchecked');
        myStorage.setItem('isChecked', 'false');
      }
    });

    if($('body').hasClass('woocommerce-checkout')) {
      if(myStorage.getItem('isChecked')) {
        if(myStorage.getItem('isChecked') == 'true') {
          $('#ship-to-different-address-checkbox').trigger('click')
        }
      }
    }
  }

  // Ajax Success
  //
  function successAjax(data) {
    var product = [3233, 3236, 3230, 3229, 5469, 5473, 5477];

    data = JSON.parse(data);

    $('.swatch-container').each(function() {
      var dataID = $(this).children('.p-attr-color').data('paletteid');
      var productID = $(this).children('.p-attr-color').data('productid');

      if($.inArray(dataID, data) != -1) {
        $(this).addClass('active');
        $(this).parent().find('.swatch-container.active').show();
        $(this).parent().find('.swatch-container:not(.active)').hide();

        if($.inArray(productID, product) != -1) {
          var position = $.inArray(productID, product);
          product[position] = 0;

          if(!$('.swatch-container > span[data-paletteid='+dataID+']').hasClass('active')) {
            $('.swatch-container > span[data-paletteid='+dataID+']').trigger('click').parent().addClass('active').show();
          }
        }
      }
    });

    $('.shop-container li.product.type-product').animate({
      opacity: 1,
    }, 750);
  }

  function geolocalisation(data) {
    var price = [];
    var ctp = 0;
    data = JSON.parse(data);

    $('.address-container').empty().append(data[2]);

    if(data[0] == 'CA') {

      $('.address-location').html('Canada');

      if($("body").hasClass('privacy-policy')) {
        $('.usa_policy').css('display', 'none');
        $('.cad_policy').css('display', 'block');
      }
      if($("body").find('.usa_terms').length > 0 && $("body").find('.cad_terms').length > 0) {
        $('.usa_terms').css('display', 'none');
        $('.cad_terms').css('display', 'block');
      }
      if($("body").find('.usa_return').length > 0 && $("body").find('.cad_return').length > 0) {
        $('.usa_return').css('display', 'none');
        $('.cad_return').css('display', 'block');
      }
      if($("body").find('.usa_warranty').length > 0 && $("body").find('.cad_warranty').length > 0) {
        $('.usa_warranty').css('display', 'none');
        $('.cad_warranty').css('display', 'block');
      }

      if($('body').hasClass('woocommerce-checkout')) {
        $('#billing_country').val(data[0]).trigger('change');
        $('#shipping_country').val(data[0]).trigger('change');
      }

      if($("body").hasClass('page-id-266')) {
        $('select[name="sender-country"] option[value="Canada"]').attr('selected', 'selected');
      }

      $('.geolocatePrices').each(function() {
        price.push($(this).data('price-cad'));
      });
      $('.geolocatePrices .woocommerce-Price-amount').each(function(){
        $(this).html('<span class="woocommerce-Price-currencySymbol">$</span>'+price[ctp]+'&nbsp;CAD</span>');
        ctp++;
      });
    }
    else {
      
      $('.address-location').html('US');
      
      if($("body").hasClass('privacy-policy')) {
        $('.cad_policy').css('display', 'none');
        $('.usa_policy').css('display', 'block');
      }
      if($("body").find('.usa_terms').length > 0 && $("body").find('.cad_terms').length > 0) {
        $('.cad_terms').css('display', 'none');
        $('.usa_terms').css('display', 'block');
      }
      if($("body").find('.usa_return').length > 0 && $("body").find('.cad_return').length > 0) {
        $('.cad_return').css('display', 'none');
        $('.usa_return').css('display', 'block');
      }
      if($("body").find('.usa_warranty').length > 0 && $("body").find('.cad_warranty').length > 0) {
        $('.cad_warranty').css('display', 'none');
        $('.usa_warranty').css('display', 'block');
      }

      if($('body').hasClass('woocommerce-checkout')) {
        $('#billing_country').val(data[0]).trigger('change');
        $('#shipping_country').val(data[0]).trigger('change');
      }

      if($("body").hasClass('page-id-266')) {
        $('select[name="sender-country"] option[value="United States of America"]').attr('selected', 'selected');
      }

      $('.geolocatePrices').each(function() {
        price.push($(this).data('price-usd'));
      });
      $('.geolocatePrices .woocommerce-Price-amount').each(function(){
        $(this).html('<span class="woocommerce-Price-currencySymbol">$</span>'+price[ctp]+'&nbsp;USD</span>');
        ctp++;
      });
    }
  }

  // Google Tag Manager
  //
  function initLeonardGTMTracking() {
    // Track CTA pointing to a «Leads Form»
    // -------
    var arrLeonardGTMTrackingCTA = [];
    for(var i=0; i<arrLeonardGTMTrackingFormPath.length; i++){
      arrLeonardGTMTrackingCTA.push("a.btn[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a.button[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a.Button[href*='" + arrLeonardGTMTrackingFormPath[i] + "']");
    }

    // Custom CSS rules here
    // arrLeonardGTMTrackingCTA.push(".custom-rule-for-CTA-pointing-to-leads-form a");

    $(arrLeonardGTMTrackingCTA.join(", ")).addClass("gtm-form-view");

    // Track «Leads form» submit button click
    // -------
    if(arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
      $("form button, form input[type=submit]").addClass("gtm-form-submited");
    }

    //if(arrLeonardGTMTrackingFormPathCTA2.indexOf(window.location.pathname) != -1) {
      //$("a.nav-child-page").addClass("gtm-cta-2");
    //}

    $('.product .woocommerce-tabs .description_tab').addClass('gtm-cta-1');
    $('.product .woocommerce-tabs .0_tab').addClass('gtm-cta-1');
    $('.product .woocommerce-tabs .reviews_tab').addClass('gtm-cta-1');

    $('.product .woocommerce-tabs #tab-reviews #submit').addClass('gtm-cta-2');

    $('.product .more_informations a').addClass('gtm-cta-3');

    $('.home .elementor-shortcode .rev-btn').addClass('gtm-cta-4');

    $('.product .summary .cart .single_add_to_cart_button').addClass('gtm-cta-5');

    $('#theme-container #theme-bread').addClass('gtm-breadcrumbs');

    setTimeout(function(e){
      $('.checkout .woocommerce-checkout-payment #place_order').addClass('gtm-form-submited');
    }, 2000);

  }

  function getNewsletterRegistration() {
    $.searchParams = function(name) {
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
      if (results == null){
         return null;
      }
      else {
         return decodeURI(results[1]) || 0;
      }
    }
    if($.searchParams('newsletter') && $.searchParams('newsletter') == 'registered') {
      $('html, body').animate({
        scrollTop: ($('#theme-footer').offset().top)
      }, 1500);
    }
  }

  // Read a page's GET URL variables and return them as an associative array.
  function getUrlVars()
  {
      var vars = [], hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for(var i = 0; i < hashes.length; i++)
      {
          hash = hashes[i].split('=');
          vars.push(hash[0]);
          vars[hash[0]] = hash[1];
      }
      return vars;
  }

  // Init same-height for a batch of element
  //
  // @return Void
  function sameHeight($objects) {
    $(window).bind("resize", {cachedObjects: $objects}, function(e) {
        var $cachedObjects = e.data.cachedObjects;
        sameHeightSet($cachedObjects);
    }).trigger("resize");
  }

  // Set same-height for a batch of cached elements
  //
  // @return Void
  function sameHeightSet($cachedObjects) {
    var max = -1;
    var h = 0;

    $cachedObjects.css({minHeight: 0});
    $cachedObjects.each(function() {
    h = $(this).height();
    max = h > max ? h : max;
    });

    $cachedObjects.each(function() {
    $(this).css({minHeight: max});
    });
  }

});